import { useState } from 'react'
import Pusher from 'pusher-js'
import jwtDecode from 'jwt-decode'

import config from 'config'
import useAutorun from 'hooks/useAutorun'
import { useUserStore } from 'store/userStore'

const useCouponUsedPusher = () => {
  const [eventData, setEventData] = useState(null)
  const { accessToken } = useUserStore()
  useAutorun(() => {
    if (!accessToken) {
      return
    }

    const { accountId } = jwtDecode(accessToken)

    if (!accountId) {
      return
    }

    const pusher = new Pusher(config.PUSHER.KEY, {
      cluster: config.PUSHER.CLUSTER,
      forceTLS: config.PUSHER.FORCE_TLS,
      authEndpoint: config.PUSHER.AUTH_ENDPOINT,
      auth: {
        headers: {
          'HK01-Auth-Schema': 'CLIENT',
          Authorization: `Bearer ${accessToken}`,
        },
      },
    })

    const channel = pusher.subscribe(`private-user-${accountId}`)
    channel.bind('EVENT_COUPON_USED', (data) => setEventData(data))

    return () => {
      pusher.disconnect()
    }
  })

  return eventData
}

export default useCouponUsedPusher
